// src/components/AchievementModal/AchievementModal.js
import React, { useEffect, useState } from 'react';
import styles from './AchievementModal.module.css';

const AchievementModal = ({ achievement, isVisible, onClose }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsAnimating(true);
      // Auto-close after 4 seconds
      const timer = setTimeout(() => {
        onClose();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible || !achievement) return null;

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'Combat': return '⚔️';
      case 'Economic': return '💰';
      case 'Progression': return '📈';
      case 'Skills': return '💪';
      case 'Minigames': return '🎯';
      case 'Buildings': return '🏗️';
      case 'Special': return '⭐';
      default: return '🏆';
    }
  };

  const getTierColor = (tier) => {
    switch (tier) {
      case 1: return '#8B4513'; // Bronze
      case 2: return '#C0C0C0'; // Silver
      case 3: return '#FFD700'; // Gold
      case 4: return '#E6E6FA'; // Platinum
      default: return '#FFD700'; // Default gold
    }
  };

  return (
    <div className={`${styles.modalOverlay} ${isAnimating ? styles.visible : ''}`}>
      <div className={`${styles.modalContent} ${isAnimating ? styles.slideIn : ''}`}>
        {/* Achievement Icon */}
        <div className={styles.iconContainer}>
          <div className={styles.achievementIcon} style={{ borderColor: getTierColor(achievement.tier) }}>
            {getCategoryIcon(achievement.category)}
          </div>
        </div>

        {/* Achievement Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>🏆 Achievement Unlocked!</h2>
          <div className={styles.achievementTitle} style={{ color: getTierColor(achievement.tier) }}>
            {achievement.title}
          </div>
        </div>

        {/* Achievement Details */}
        <div className={styles.details}>
          <p className={styles.description}>{achievement.description}</p>
          <div className={styles.category}>
            <span className={styles.categoryLabel}>Category:</span>
            <span className={styles.categoryValue}>{achievement.category}</span>
          </div>
          {achievement.seriesName && (
            <div className={styles.series}>
              <span className={styles.seriesLabel}>Series:</span>
              <span className={styles.seriesValue}>{achievement.seriesName}</span>
              {achievement.tier && (
                <span className={styles.tier} style={{ color: getTierColor(achievement.tier) }}>
                  Tier {achievement.tier}
                </span>
              )}
            </div>
          )}
        </div>

        {/* Reward */}
        <div className={styles.reward}>
          <div className={styles.rewardIcon}>💰</div>
          <div className={styles.rewardText}>
            <span className={styles.rewardAmount}>+{achievement.goldReward}G</span>
            <span className={styles.rewardLabel}>Gold Reward</span>
          </div>
        </div>

        {/* Close Button */}
        <button 
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close achievement modal"
        >
          ✕
        </button>

        {/* Celebration Effects */}
        <div className={styles.celebrationEffects}>
          <div className={styles.sparkle1}>✨</div>
          <div className={styles.sparkle2}>⭐</div>
          <div className={styles.sparkle3}>✨</div>
          <div className={styles.sparkle4}>⭐</div>
        </div>
      </div>
    </div>
  );
};

export default AchievementModal; 